import { ReactNode } from 'react';
import { GrowlNotificationSupportedVariant } from '@gaiads/telia-react-component-library';
import produce from 'immer';
import * as actionTypes from '../actions/actionTypes';
import { NotificationActions } from '../../types';

export interface NotificationReducer {
  notification: {
    text: string;
    i18nKey: string | null;
    variant: GrowlNotificationSupportedVariant;
    show: boolean;
    linkText: string;
    linkHref: string;
    autoCloseInMs: number | null;
  };
  modal: {
    open: boolean;
    title: string;
    children: ReactNode | null;
    acceptButtonText: string;
    closeButtonText: string;
    onAccept: () => void;
    onClose: () => void;
    size: 'md' | 'lg';
    destructive: boolean;
    classes: string;
  };
}

export const initialState: NotificationReducer = {
  notification: {
    text: '',
    i18nKey: null,
    variant: 'success',
    show: false,
    linkText: '',
    linkHref: '',
    autoCloseInMs: null,
  },
  modal: {
    open: false,
    title: '',
    children: null,
    acceptButtonText: '',
    closeButtonText: '',
    onAccept: () => {},
    onClose: () => {},
    size: 'md',
    destructive: false,
    classes: '',
  },
};

const reducer = (state: NotificationReducer = initialState, action: NotificationActions): NotificationReducer => {
  switch (action.type) {
    case actionTypes.SHOW_GROWL_NOTIFICATION:
      return produce(state, draft => {
        draft.notification.text = action.text;
        draft.notification.variant = action.variant;
        draft.notification.show = true;
        draft.notification.linkText = action.linkText;
        draft.notification.linkHref = action.linkHref;
        draft.notification.autoCloseInMs = action.autoCloseInMs;
      });
    case actionTypes.SHOW_GROWL_NOTIFICATION_TRANSLATED:
      return produce(state, draft => {
        draft.notification.i18nKey = action.i18nKey;
        draft.notification.variant = action.variant;
        draft.notification.show = true;
        draft.notification.linkText = action.linkText;
        draft.notification.linkHref = action.linkHref;
        draft.notification.autoCloseInMs = action.autoCloseInMs;
      });
    case actionTypes.CLOSE_GROWL_NOTIFICATION:
      return produce(state, draft => {
        draft.notification = initialState.notification;
      });
    case actionTypes.MODAL_SHOW:
      return produce(state, draft => {
        draft.modal.open = true;
        draft.modal.title = action.title;
        draft.modal.children = action.children || null;
        draft.modal.acceptButtonText = action.acceptButtonText;
        draft.modal.closeButtonText = action.closeButtonText;
        draft.modal.onAccept = action.onAccept;
        draft.modal.onClose = action.onClose;
        draft.modal.size = action.size || initialState.modal.size;
        draft.modal.destructive = action.destructive || false;
        draft.modal.classes = action.classes || '';
      });
    case actionTypes.MODAL_CLOSE:
      return produce(state, draft => {
        draft.modal = initialState.modal;
      });
    default:
      return state;
  }
};

export default reducer;
